module.exports = __webpack_public_path__ + "img/card-reverse-design.3159449a.png";